// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"RU-z","inlineTitle":"SU-z","sponsoredAdsWrapper":"TU-z","marketplaceRecosWrapper":"UU-z"};